import {useState} from 'react';
import {Col, FormGroup, Label, Input} from '@polichat/flamboyant';
import { useGlotaT } from '../../../../../hooks/useGlotaTranslation';

function TemplateShortcutInput({onUpdate, initialValue}) {
  // Traduções
  const shortcut = useGlotaT('spa.messageBuilder.shortcut');
  const shortcutPlaceholder = useGlotaT('spa.messageBuilder.shortcutPlaceholder');
  
  const [templateShortcut, setTemplateShortcut] = useState({
    templateShortcut: initialValue
  });

  const handleInputChange = ({target: {name, value}}) => {
    setTemplateShortcut({
      ...templateShortcut,
      [name]: value
    });
    handleTemplateShortcutData({
      ...templateShortcut,
      [name]: value
    })
  };

  const handleTemplateShortcutData = (data) => {
    onUpdate(data)
  }

  return (
  <Col sm={12} md={6} >
    <FormGroup>
      <Label>{shortcut}</Label>
      <Input
        type="text"
        id="template-shortcut"
        name= "templateShortcut"
        placeholder={shortcutPlaceholder}
        value={templateShortcut.templateShortcut}
        onChange={handleInputChange}
        />
    </FormGroup>
  </Col>
)}

export default TemplateShortcutInput;
